import {
  type PopupProps,
  Leaderboard as LeaderboardPopup
} from '@CS/components/Popups';

import API from '@/services/api';
import { connect } from 'react-redux';
import { useDataLayer } from '@CS/hooks';
import { useCurrentWeek } from '@/hooks';
import type { Username } from '@/redux/user/types';
import { getUserUsername, getUserTeamId } from '@/redux/user/selectors';

type LeaderboardProps = PopupProps & {
  username: Username;
  teamId?: string;
  game: number;
};

const Leaderboard = ({
  teamId = '',
  username,
  game,
  ...props
}: LeaderboardProps) => {
  const campaignGame = API.getCampaignGame(game);
  const week = useCurrentWeek(campaignGame);

  const getWeekScores = async (week: number) => {
    const leaderboard = await API.getCampaignLeaderboard(game, {
      rangeNumber: week + 1,
      teamId
    });

    const {
      position = -1,
      participant: { score = 0 }
    } = leaderboard.my ?? {
      participant: {}
    };

    return {
      userData: { name: username ?? '', position, score },

      weekScores: leaderboard.items.map(({ user, score }) => ({
        name: user.username,
        score: score
      }))
    };
  };

  useDataLayer({
    event: 'page_view',
    eventProperties: {
      page_virtual_path: '/GGA25/games/run/leaderboard',
      page_type: 'Golden_GetAway_2025'
    }
  });

  return (
    <LeaderboardPopup
      getWeekScores={getWeekScores}
      currentWeek={week}
      weeks={false}
      {...props}
    />
  );
};

const mapStateToProps = (state: never) => ({
  username: getUserUsername(state),
  teamId: getUserTeamId(state)
});

export default connect(mapStateToProps)(Leaderboard);
